import React, { useState, useEffect, useContext, useRef } from 'react';
import OwlCarousel from "react-owl-carousel";
import { getImages } from '../../Components/Const';
import ModalLayout from '../../Components/Modals/ModalLayout';
import SelectFilterModal from '../../Components/Frontend/Inventory/SelectFilterModal';
import ReadMore from '../../Components/Frontend/Common/ReadMore';
import { VehicleContext } from '../../Components/Context/VehicleContext';
import FrontLayout from '../../Components/Layouts/FrontLayout';
import InfiniteScroll from 'react-infinite-scroll-component';

const Inventory = () => {
    const [isSticky, setIsSticky] = useState(false);
    const [pageSize, setPageSize] = useState(20);
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [isOpacity, setIsOpacity] = useState(true);
    const { vehicleData, filteredVehicleData, setSearchText, numberFormatter, currentFilterData, setCurrentFilterData, activeFilter, setActiveFilter, setSelectedVehicles } = useContext(VehicleContext);
    const [timer, setTimer] = useState(null);
    const [vehicleSearchText, setVehicleSearchText] = useState("");
    useEffect(() => {
        if (filteredVehicleData) {
            setIsDataLoaded(false);
            setTimeout(() => {
                setIsOpacity(false);
            }, 100);
        }
    }, [filteredVehicleData]);
    const queryParameters = new URLSearchParams(window.location.search);
    const all_inventory = queryParameters.has("all_inventory");
    useEffect(() => {
        setSelectedVehicles(!all_inventory);
    }, [all_inventory])
    const searchInputChanged = (val) => {
        setVehicleSearchText(val);
        clearTimeout(timer);
        const newTimer = setTimeout(() => {
            setSearchText(val);
        }, 500)
        setTimer(newTimer)
    }

    useEffect(() => {
        const handleScroll = () => {
            const topSection = document.getElementById('srpFilter');
            if (topSection) {
                const topSectionRect = topSection.getBoundingClientRect();
                const isTopSectionVisible = topSectionRect.top <= 0;
                setIsSticky(isTopSectionVisible);
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    const [srpFilter, setSrpFilter] = useState(false);
    const handelSrpFilter = () => {
        setSrpFilter(true)
    }
    const closeSrpFilter = () => {
        setSrpFilter(false)
    }
    const [openFilterModal, setOpenFilterModal] = useState(false);
    const [filterData, setFilterData] = useState();
    const handleFilterModal = (field) => {
        setOpenFilterModal(true);
        setFilterData(currentFilterData[field]);
        console.log(currentFilterData[field]);
        setActiveFilter(field);
    }
    const closeMakeModal = () => {
        setOpenFilterModal(false)
    }
    const updateFilter = (filter_data) => {
        setCurrentFilterData({ ...currentFilterData, [activeFilter]: filter_data });
    }
    // Scrollmagic mobile conditions 
    const [isMobile, setIsMobile] = useState(false);
    const handleResize = () => {
        setIsMobile(window.innerWidth < 992);
    };
    useEffect(() => {
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // Custom Pagination 
    const [currentPage, setCurrentPage] = useState(1);
    const filteredDataWithImages = filteredVehicleData && filteredVehicleData.filter(vehicle => vehicle.has_images);
    const totalPages = Math.ceil(filteredDataWithImages.length / pageSize);
    const paginatedData = filteredVehicleData && filteredVehicleData
        .filter(vehicle => vehicle.has_images)
        .slice((currentPage - 1) * pageSize, currentPage * pageSize);
    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };
    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };
    const handlePreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const renderPagination = () => {
        const pageNumbers = [];

        if (totalPages <= 6) {
            for (let i = 1; i <= totalPages; i++) {
                pageNumbers.push(i);
            }
        } else {
            pageNumbers.push(1, 2);

            if (currentPage > 3) {
                pageNumbers.push('...');
            }

            if (currentPage > 2 && currentPage < totalPages - 1) {
                pageNumbers.push(currentPage);
            }
            if (currentPage < totalPages - 2) {
                pageNumbers.push('...');
            }
            pageNumbers.push(totalPages - 1, totalPages);
        }
        return pageNumbers.map((page, index) => (
            <li
                key={index}
                className={`page-item ${page === currentPage ? 'active' : ''} ${page === '...' ? 'disabled' : ''}`}
            >
                {page === '...' ? (
                    <span className="page-link">...</span>
                ) : (
                    <button
                        type='button'
                        className="page-link"
                        onClick={() => handlePageChange(page)}
                    >
                        {page}
                    </button>
                )}
            </li>
        ));
    };

    // Infinite Scroll
    const totalLength = filteredVehicleData && filteredVehicleData.filter(v => !v.has_images).length;
    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const filteredData = filteredVehicleData && filteredVehicleData?.filter(v => !v.has_images);
    const fun = ()=> {
        console.log("fun")
        return '';
    }
    const fetchData = async () => {
        if (loading || !Array.isArray(filteredData)) {
            return;
        }
        setLoading(true);
        // fun();
        // setTimeout(()=>{
            const newData = filteredData.slice((page - 1) * 10, page * 10);
            if (newData.length === 0) {
                setLoading(false);
                return;
            }
            setLoading(false); 
            // fun();
            setData((prevData) => {
                const updatedData = [...prevData, ...newData];
                return updatedData;
            });
        // },1000)
        
    };

    const observer = useRef(null);
    const loaderRef = useRef(null);

    const handleScroll = (entries) => {
        const target = entries[0];
        if (target.isIntersecting && !loading) {
            setPage((prevPage) => prevPage + 1);
        }
    };
    useEffect(() => {
        if (filteredVehicleData) {
            setPage(1);
            setData([]);
            fetchData();
        }
    }, [filteredVehicleData]);
    useEffect(() => {
        fetchData();
    }, [page]);
    useEffect(() => {
        observer.current = new IntersectionObserver(handleScroll, {
            root: null, 
            rootMargin: "0px 0px 200px 0px",
            threshold: 0.5,
        });

        if (loaderRef.current) {
            observer.current.observe(loaderRef.current);
        }

        return () => {
            if (loaderRef.current) {
                observer.current.unobserve(loaderRef.current);
            }
        };
    }, [loading]);
    
    const [tooltipVisible, setTooltipVisible] = useState(null);
    const handleCopy = (vin) => {
        const textArea = document.createElement('textarea');
        textArea.value = vin;
        textArea.style.position = 'absolute';
        textArea.style.left = '-9999px';
        document.body.appendChild(textArea);
        textArea.select();
        try {
            document.execCommand('copy');
            showTooltip(vin);
        } catch (err) {
            console.error('Failed to copy text:', err);
        }
        document.body.removeChild(textArea);
    };

    const showTooltip = (vin) => {
        setTooltipVisible(vin);
        setTimeout(() => {
            setTooltipVisible(false);
        }, 2000);
    };
    return (
        <>
        {console.log("loading", loading)}
            <FrontLayout>
                <section className='inventory-wrap'>
                    <div className='container d-lg-none'>
                        <div className='d-flex mb-4 align-items-center justify-content-between mob-filter-heading'>
                            <div className='main-heading fw-700 text-black'>Latest Inventory</div>
                            <div className='d-lg-none'>
                                <button type='button' className='filter-btn' onClick={handelSrpFilter}>Filter <img src={getImages('filter_icon.svg')} alt='icon' /></button>
                            </div>
                        </div>
                    </div>
                    <div id="srpFilter" className={`product-block ${isSticky ? 'sticky' : ''}`}>
                        <div className='srp-filter-block'>
                            <div className='container'>
                                <div className='row align-items-center'>
                                    <div className='col-lg-4 col-12'>
                                        <div className='d-flex align-items-center'>
                                            <div className='d-flex inv-search-box'>
                                                <input type='text' className='form-control'
                                                    placeholder='Search As You Type'
                                                    value={vehicleSearchText}
                                                    onChange={(e) => { searchInputChanged(e.target.value) }}
                                                />
                                                <button className='inv-search-icon'></button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={`col-md-8 text-end srp-filter-blk ${srpFilter ? "active" : ""}`}>
                                        <div className='srp-filter-header d-lg-none'>
                                            <div>Filters</div>
                                            <button className='sf-close-icon' onClick={closeSrpFilter} type='button'><img src={getImages('close-anticon.svg')} /></button>
                                        </div>
                                        <div className='srp-filter-body d-inline-flex gap-3'>
                                            <div className='d-lg-none mb-4'>
                                                <div className='sm-title text-start'>Applied Filters</div>
                                                <div className='mt-3 text-start'>
                                                    <span className='sf-tag me-2'>2023 <img src={getImages('cross_icon.svg')} /></span>
                                                    <span className='sf-tag me-2'>Porsche <img src={getImages('cross_icon.svg')} /></span>
                                                </div>
                                            </div>
                                            <button className='srp-filter-btn' type='button' onClick={() => handleFilterModal('year')}>
                                                <img src={getImages('event.svg')} alt='icon' />
                                                <span>Year</span>
                                                <span className='srp-fl-arrow'></span>
                                            </button>
                                            <button className='srp-filter-btn' type='button' onClick={() => handleFilterModal('make')}>
                                                <img src={getImages('location_city.svg')} alt='icon' />
                                                <span>Make</span>
                                                <span className='srp-fl-arrow'></span>
                                            </button>
                                            <button className='srp-filter-btn' type='button' onClick={() => handleFilterModal('model')}>
                                                <img src={getImages('directions_car.svg')} alt='icon' />
                                                <span>Model</span>
                                                <span className='srp-fl-arrow'></span>
                                            </button>
                                            <button className='srp-filter-btn' type='button' onClick={() => handleFilterModal('trim')}>
                                                <img src={getImages('loupe.svg')} alt='icon' />
                                                <span>Trim</span>
                                                <span className='srp-fl-arrow'></span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='container'>
                            <div className='product-list mt-4'>
                                <div className='main-heading fw-500 text-black mb-3'>Inventory With Photos ({filteredDataWithImages?.length})</div>
                                <div className='row'>
                                    {isDataLoaded ?
                                        <div className='py-5 my-5 text-center'>
                                            <img src={getImages('gears_green.svg')} alt='gears' />
                                        </div> :
                                        paginatedData && paginatedData.map((vehicle, index) =>
                                            vehicle.LatestDrop ? (
                                                <div className='col-md-6 mb-4 animated zoomIn'
                                                    style={{
                                                        visibility: 'visible',
                                                        animationDelay: '0.2s',
                                                        animationName: 'zoomIn'
                                                    }}
                                                    key={vehicle.vin}
                                                >
                                                    <div className='pro-box pro-full-width d-flex align-items-center'>
                                                        <div className='pro-top'>
                                                            <img src={vehicle.images[0]} alt='srp' />
                                                        </div>
                                                        <div className='pro-bottom p-0 ps-4'>
                                                            <div className='lt-main-title text-uppercase mb-4'>Latest Drop</div>
                                                            <div className="sm-title mb-2 text-white">{vehicle.vehicle_name}</div>
                                                            <div className='d-flex align-items-center justify-content-between mt-5 pt-2'>
                                                                {/* <div className='d-flex align-items-center'>
                                                                    <div className="xs-title text-white"><span className='font-1em fw-300'>Price:</span> {numberFormatter(vehicle.price, true)}</div>
                                                                </div> */}
                                                                <div>
                                                                    <div className="xs-title text-white"><span className='font-1em fw-300'>Mileage:</span> {numberFormatter(vehicle.mileage)}</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ) :
                                                (
                                                    <div className='col-md-3 mb-4 animated zoomIn'
                                                        style={{
                                                            visibility: 'visible',
                                                            animationDelay: '0.2s',
                                                            animationName: 'zoomIn'
                                                        }}
                                                        key={vehicle.vin}
                                                    >
                                                        <div className='pro-box'>
                                                            <div className={`pro-content`}>
                                                                <div className='before-hover'>
                                                                    <div className='pro-top'>
                                                                        <img src={vehicle.images[0]} alt='srp' />
                                                                    </div>
                                                                    <div className='pro-bottom'>
                                                                        <div className="d-flex align-items-center justify-content-between mb-md-1 mb-4">
                                                                            <div className="sm-title text-white font-0-9em fw-700">{vehicle.vehicle_name}</div>
                                                                            <div className='d-none d-md-block'>
                                                                                <button className='info-icon'>
                                                                                    <img src={getImages('info-icon.svg')} alt='icon' />
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                        <div className="d-flex align-items-center justify-content-between mt-2">
                                                                            {/* <div className="xs-title font-0-9em fw-400 text-white d-md-none">{numberFormatter(vehicle.mileage)} mi</div> */}
                                                                            {/* <div className="sm-title font-0-9em fw-700 text-white">{numberFormatter(vehicle.price, true)}</div> */}
                                                                            <div className="sm-title font-0-9em fw-700 text-white">{numberFormatter(vehicle.mileage)} mi</div>
                                                                            <div className='d-none d-md-block'><a className="blue-btn" href={"/vdp?vin=" + vehicle.vin}>Vehicle Details</a></div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className='after-hover'>
                                                                    <div className='pro-top'>
                                                                        <OwlCarousel
                                                                            className="owl-theme srplist-slider"
                                                                            loop={true}
                                                                            margin={0}
                                                                            items={1}
                                                                            nav={true}
                                                                            dots={true}
                                                                            autoplay={true}
                                                                            autoplayTimeout={2000}
                                                                        >
                                                                            {vehicle.images.slice(0, 3).map((v, i) => {
                                                                                return (
                                                                                    <div className='item' key={i}>
                                                                                        <img src={v} alt='srp' />
                                                                                    </div>
                                                                                )
                                                                            })}
                                                                        </OwlCarousel>
                                                                    </div>
                                                                    <div className='pro-bottom'>
                                                                        <div className="d-flex align-items-center justify-content-between mb-2">
                                                                            <div className='d-flex align-items-center w-60'>
                                                                                <div className='xs-title fw-400 w-30 text-white'>Stock #</div>
                                                                                <div className='sm-title w-70 text-white'>{vehicle.stockno}</div>
                                                                            </div>
                                                                            <div className='d-flex align-items-center w-40'>
                                                                                <div className='xs-title fw-400 w-60 text-white'>Interior Color</div>
                                                                                <div className='sm-title w-40 text-white'>{vehicle.interior_color}</div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="d-flex align-items-center justify-content-between mb-2">
                                                                            <div className='d-flex align-items-center w-60'>
                                                                                <div className='xs-title fw-400 w-30 text-white'>VIN</div>
                                                                                <div className='sm-title w-70 text-white'>{vehicle.vin}</div>
                                                                            </div>
                                                                            <div className='d-flex align-items-center w-40'>
                                                                                <div className='xs-title fw-400 w-60 text-white'>Exterior Color</div>
                                                                                <div className='sm-title w-40 text-white'>{vehicle.exterior_color}</div>
                                                                            </div>
                                                                        </div>
                                                                        <hr className='custom-hr' />
                                                                        {vehicle.description && 
                                                                            <ReadMore
                                                                                key={index}
                                                                                text={vehicle.description}
                                                                                maxChars={230}
                                                                                sectionId="aboutVdp"
                                                                                readMoreUrl={"/inventory/" + vehicle.make + '-' + vehicle.model?.replace(/\s+/g, '') + '-' + vehicle.trim + '-' + vehicle.vin?.slice(-4)}
                                                                            />
                                                                        }
                                                                        {/* <p>We are proud to present this beautiful Porsche Taycan. Finished in Volcano Grey lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt &nbsp;<span className='text-green'>Read More</span></p> */}
                                                                        <div className="d-flex align-items-center justify-content-between mt-4 pt-2 srp-actions-flex">
                                                                            {/* <div>
                                                                            <button type='button' className='view-sticker-btn text-white'><span className='doc_icon'></span> View Window Sticker</button>
                                                                        </div> */}
                                                                            <div className='w-100 text-center'><a className="blue-btn" href={"/inventory/vdp?vin=" + vehicle.vin} >Vehicle Details</a></div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                        )
                                    }
                                </div>
                                {filteredDataWithImages?.length <= pageSize || paginatedData?.length &&
                                    <div className='mt-5 text-center custom-pagination'>
                                        <nav aria-label="Page navigation example" className='d-inline-block'>
                                            <ul className="pagination">
                                                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                    <button className="page-link back-btn me-5" type="button" onClick={handlePreviousPage}>Back</button>
                                                </li>
                                                {renderPagination()}
                                                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                    <button className="page-link next-btn ms-5" type="button" onClick={handleNextPage}>Next</button>
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </section>
                <section className='inventory-dtl-wrap pb-3'>
                    <div className='container'>
                        <div className='main-heading fw-500 text-black mb-3'>Inventory Without Photos ({totalLength})</div>
                        {isMobile ?
                            data.map((vehicle, index) => (
                                <div className='mob-inv-box' key={index}>
                                    <div className='d-flex align-items-center justify-content-between mb-2'>
                                        <div>
                                            <div className='inv-title1 fw-500 theme-black'>{vehicle.year} {vehicle.make}</div>
                                            <div className='inv-title2'>{vehicle.model}, {vehicle.trim}</div>
                                        </div>
                                        <div>
                                            <a className="text-nowrap blue-btn" href={"/inventory/vdp?vin=" + vehicle.vin}>View Details</a>
                                        </div>
                                    </div>
                                    <div className='d-flex align-items-center justify-content-between'>
                                        <div className='d-flex align-items-center'>
                                            <div className='inv-title2 me-3'>VHR</div>
                                            <div className='d-inline-flex'>
                                                <div className='vhr-box me-2' style={{ background: vehicle.bad_carfax ? "#c9c94f" : "#4EC960" }}></div>
                                                <div className='vhr-box' style={{ background: vehicle.bad_autocheck ? "#c9c94f" : "#4EC960" }}></div>
                                            </div>
                                        </div>
                                        <div className='d-flex align-items-center'>
                                            <div className='inv-title2 me-3'>Color:</div>
                                            <div className='inv-title1 fw-500 theme-black'>{vehicle.exterior_color}</div>
                                        </div>
                                        <div className='d-flex align-items-center'>
                                            <div className='inv-title2 me-3'>Miles:</div>
                                            <div className='inv-title1 fw-500 theme-black'>{numberFormatter(vehicle.mileage)}</div>
                                        </div>
                                    </div>
                                </div>
                            ))
                            :
                            <>
                                    <div className='custom-table2 inventory-dtl-table'>
                                        <table className='w-100'>
                                            <thead>
                                                <tr>
                                                    <th>Vehicle Details</th>
                                                    <th>VIN</th>
                                                    <th className='text-center'>Ext Color</th>
                                                    <th className='text-center'>Miles</th>
                                                    <th className='text-center'>VHR</th>
                                                    <th className='text-center'>&nbsp;</th>
                                                    <th className='text-center'>&nbsp;</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {data.map((vehicle, index) => (
                                                    <tr key={index}>
                                                        <td className='d-flex align-items-center'>
                                                            <div className='idl-img-box'>
                                                                <a href={"/inventory/vdp?vin=" + vehicle.vin}><img className='idl-img' src={getImages(`logos/${vehicle.make}.png`)} alt='Inventory' /></a>
                                                            </div>
                                                            <div className='ps-4'>
                                                                <a href={"/inventory/vdp?vin=" + vehicle.vin}>
                                                                    <div className='inv-title1 fw-500'>{vehicle.year} {vehicle.make}</div>
                                                                    <div className='inv-title2'>{vehicle.model}, {vehicle.trim}</div>
                                                                </a>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className='d-flex align-items-center'>
                                                                <div className='d-inline-block'>
                                                                    <a href={"/inventory/vdp?vin=" + vehicle.vin} className='inv-vin-no'>
                                                                        {vehicle.vin}
                                                                    </a>
                                                                </div>
                                                                <div className='ms-2'>
                                                                    <span className='position-relative copy-info'>
                                                                        <button type='button' onClick={()=>handleCopy(vehicle.vin)} className='copy-icon copy_icon'></button>
                                                                        {tooltipVisible === vehicle.vin && <span className='copy-tooltip'>Copied!</span>} 
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td className='inv-title1 text-center'>{vehicle.exterior_color}</td>
                                                        <td className='inv-title1 text-center'>{numberFormatter(vehicle.mileage)}</td>
                                                        <td className='text-center'>
                                                            <div className='d-inline-flex'>
                                                                <div className='vhr-box me-2' style={{ background: vehicle.bad_carfax ? "#c9c94f" : "#4EC960"  }}></div>
                                                                <div className='vhr-box' style={{ background: vehicle.bad_autocheck ? "#c9c94f" : "#4EC960" }}></div>
                                                            </div>
                                                        </td>
                                                        <td className='w-5 text-center'>
                                                            <button className='edit-icon' type='button'></button>
                                                        </td>
                                                        <td className='w-15 text-center'>
                                                            <a className="text-nowrap blue-btn" href={"/inventory/vdp?vin=" + vehicle.vin}>View Details</a>
                                                        </td>
                                                    </tr>
                                                ))}
                                                 {/* {(data.length < filteredData.length && loading) && (
                                                    <tr>
                                                        <td colSpan={7}>
                                                            <p className='text-center'>Loading...</p>
                                                            {console.log("Loading More data")}
                                                        </td>
                                                    </tr>
                                                )} */}
                                            </tbody>
                                        </table>
                                        {/* {(data.length < filteredData.length) && ( */}
                                            <div ref={loaderRef} style={{ height: "70px", textAlign:'center' }}>
                                            {(data.length < filteredData.length) && ('Loading...')}
                                            </div>
                                        {/* )} */}
                                    </div>
                            </>
                        }
                    </div>
                </section>
            </FrontLayout>
            <ModalLayout open={openFilterModal} close={closeMakeModal} whiteThemeCls='true' modalWidth={970}>
                <SelectFilterModal close={closeMakeModal} filterData={filterData} updateFilter={updateFilter} activeFilter={activeFilter} />
            </ModalLayout>
        </>
    )
}

export default Inventory